import { render, staticRenderFns } from "./CarouselRow.vue?vue&type=template&id=d47bd4ee&scoped=true&"
import script from "./CarouselRow.vue?vue&type=script&lang=js&"
export * from "./CarouselRow.vue?vue&type=script&lang=js&"
import style0 from "./CarouselRow.vue?vue&type=style&index=0&id=d47bd4ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47bd4ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
